import { ANY, CITY, DISCIPLINE, EMPLOYMENT_TYPE, ROLE } from '../constants';

export const getSeoSerpsTitleTag = (
  category: string,
  categoryValue: string,
  subcategory?: string,
  subcategoryValue?: string
) => {
  const capitalizedCategoryValue = capitalizeFirstLetter(categoryValue);
  const capitalizedSubcategoryValue = subcategoryValue ? capitalizeFirstLetter(subcategoryValue) : undefined;

  switch (category) {
    case ANY:
      return { term: capitalizedCategoryValue, ...dateToLocalizedString() };
    case EMPLOYMENT_TYPE:
      return capitalizedSubcategoryValue
        ? {
            employmentType: capitalizedCategoryValue,
            city: capitalizedSubcategoryValue,
            ...dateToLocalizedString(),
          }
        : undefined;
    case CITY:
      return dateToLocalizedString();
    case ROLE:
      if (subcategory && categoryValue) {
        return { role: capitalizedCategoryValue, city: capitalizedSubcategoryValue || '', ...dateToLocalizedString() };
      }
      return categoryValue ? { role: capitalizedCategoryValue, ...dateToLocalizedString() } : undefined;
    default:
      return undefined;
  }
};

export const getSeoSerpsMetaDescriptionValues = (
  category: string,
  categoryValue: string,
  totalJobs: number,
  subcategory?: string,
  subcategoryValue?: string
) => {
  const capitalizedCategoryValue = capitalizeFirstLetter(categoryValue);
  const capitalizedSubcategoryValue = subcategoryValue ? capitalizeFirstLetter(subcategoryValue) : undefined;

  switch (category) {
    case ANY:
      return { postings: totalJobs, term: capitalizedCategoryValue };
    case EMPLOYMENT_TYPE:
      return getEmploymentTypeMetaDescriptions(
        capitalizedCategoryValue,
        subcategory,
        capitalizedSubcategoryValue,
        totalJobs
      );
    case CITY:
      return { postings: totalJobs, city: capitalizedCategoryValue };
    case ROLE:
      if (subcategory === CITY) {
        return { postings: totalJobs, role: capitalizedCategoryValue, city: capitalizedSubcategoryValue };
      }
      return { postings: totalJobs, role: capitalizedCategoryValue };
    default:
      return undefined;
  }
};

const getEmploymentTypeMetaDescriptions = (
  categoryValue: string,
  subcategory?: string,
  subcategoryValue?: string,
  totalJobs?: number
) => {
  switch (subcategory) {
    case CITY:
      return { postings: totalJobs, employmentType: categoryValue, city: subcategoryValue };
    case DISCIPLINE:
      return { term: subcategoryValue, job_type: categoryValue };
    case ROLE:
      return { term: subcategoryValue, job_type: categoryValue };
    default:
      return { job_type: categoryValue };
  }
};

const dateToLocalizedString = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleDateString('de', { month: 'long' });
  const currentYear = currentDate.toLocaleDateString('default', { year: 'numeric' });

  return { month: currentMonth, year: currentYear };
};

export const capitalizeFirstLetter = (term: string) => term.charAt(0).toUpperCase() + term.slice(1);
